import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons'

class Footer extends Component {
    render() {
        return (
            <div>
                <footer className="bg-gray-800 border-gray-700 border-t-4 border-b-0 border-x-0 drop-shadow-lg">
                    <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
                        <div className="md:flex md:justify-between">
                            <div className="mb-6 md:mb-0">
                                <a href="/" className="flex items-center">
                                    <img src="https://i.imgur.com/vy7xdek.png" alt="logo.webp" className="w-20 md:w-15"/>
                                    <span
                                        className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">US-Arbeitsrecht.de</span>
                                </a>


                                <div className="flex items-center">
                                    <a href="https://www.instagram.com/rechtsanwalt_ulrich_schulze/" className="my-6 mx-2 cursor-pointer rounded-lg bg-gray-700 px-4 py-2 font-bold hover:bg-gray-900">
                                        <FontAwesomeIcon icon={faInstagram} className="w-5 h-auto text-white"/>
                                    </a>
                                    {/*
                                        <a href="/" className="my-6 mx-2 cursor-pointer rounded-lg bg-gray-700 px-4 py-2 font-bold hover:bg-gray-900">
                                            <FontAwesomeIcon icon={faXTwitter} className="w-5 h-auto text-white"/>
                                        </a>
                                        <a href="/" className="my-6 mx-2 cursor-pointer rounded-lg bg-gray-700 px-4 py-2 font-bold hover:bg-gray-900">
                                            <FontAwesomeIcon icon={faYoutube} className="w-5 h-auto text-white"/>
                                        </a>
                                    */}
                                </div>


                            </div>
                            <div className="right-24 grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-2">
                                {/*
                                <div>
                                    <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Weiters</h2>
                                    <ul className="text-gray-500 dark:text-gray-400 font-medium">
                                        <li className="mb-4">
                                            <a href="https://www.BlackNinja.Live/regelwerk"
                                               className="hover:underline">?</a>
                                        </li>

                                    </ul>
                                </div>
                                */}
                                <div>
                                    <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Rechtliches</h2>
                                    <ul className="text-gray-500 dark:text-gray-400 font-medium">
                                        <li className="mb-4">
                                            <a href="/impressum"
                                               className="hover:underline">Impressum</a>
                                        </li>
                                        <li>
                                            <a href="/dsgvo"
                                               className="hover:underline">Datenschutzerklärung</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8"/>
                        <div className="sm:flex sm:items-center sm:justify-between">
                            <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">© {new Date().getFullYear()} US-Arbeitsrecht.de - Alle Rechte vorbehalten</span>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Footer;